import React from 'react';
import PropTypes from 'prop-types';
import LibCameraPhoto, { FACING_MODES, IMAGE_TYPES } from 'jslib-html5-camera-photo';
import styled from 'styled-components'
import { Icon } from 'antd';
import constants from '../../config/constants'

import maskpng from './assets/MaskBookBank.png'

const ContainerCamera = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
  background-color: ${constants.color.grey};
`

const Container = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  -webkit-box-shadow: inset -2px 140px 51px 35px rgba(0,0,0,0.5);
  -moz-box-shadow: inset -2px 140px 51px 35px rgba(0,0,0,0.5);
  box-shadow: inset -2px 140px 51px 35px rgba(0,0,0,0.5);
`

const ContainerCircles = styled.div`
  position: absolute;
  left: 50%;
  bottom: 85px;
`

const OuterCircle = styled.div`
  position: absolute;
  left: -37px;
  height: 75px;
  width: 75px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  z-index: 1;
`
const InnerCircle = styled.div`
  position: absolute;
  left: 50%;
  top: 38px;
  height: 44px;
  width: 44px;
  background: white;
  border-radius: 50%;
  margin: -22px 0px 0px -22px;
  z-index: 2;
`

const ContainerMask = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  z-index: 999;
  transform: translate(-50%, -50%);
`

const Mask = styled.img`
  margin: 0 auto;
  display: block;
  width: auto;
  height: 95%;
`

const ContainerWords = styled.div`
  position: absolute;
  padding-top: 1rem;
  width: 100%;
  z-index: 1;
`

const HeaderWords = styled.h4`
  text-align: center;
  color: #fff;
`

const TitleWords = styled.h5`
  text-align: center;
  color: #fff;
`
const StyledIcon = styled(Icon)`
  font-size: 16px;
  color: ${constants.color.white} !important;
  margin-top: 0.2rem;
  position: absolute;
  z-index: 999;
  padding: 1.2rem 1rem 1.5rem;
`

const MainVideo = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Video = styled.video`
  /* width: 500px; */
  height: ${(props) => props.resolution.height}px;
  position: absolute;
`

export function getShowHideStyle (isDisplay) {
    const displayStyle = isDisplay
        ? {display: 'inline-block'}
        : {display: 'none'};
    return displayStyle;
}

export function _getMirrorCameraStyle (imageMirror) {
    const mirrorDisplayStyle = imageMirror
        ? {transform: 'rotateY(180deg)'}
        : {transform: 'none'};

    return mirrorDisplayStyle;
}

export function getVideoStyles (isDisplay, imageMirror) {
    return {
        ..._getMirrorCameraStyle(imageMirror),
        ...getShowHideStyle(isDisplay)
    };
}

export function isDynamicPropsUpdate (props, nextProps) {
    return (
        (props.idealFacingMode !== nextProps.idealFacingMode) ||
        (props.idealResolution !== nextProps.idealResolution) ||
        (props.isMaxResolution !== nextProps.isMaxResolution)
    );
}

export function printCameraInfo (info) {
    console.info('react-html5-camera-photo info:', info);
}

class Camera extends React.Component {
    constructor (props, context) {
        super(props, context);
        this.libCameraPhoto = null;
        this.showVideoTimeoutId = null;
        this.videoRef = React.createRef();
        this.state = {
            dataUri: '',
            isShowVideo: true,
            isCameraStarted: false,
            startCameraErrorMsg: ''
        };
        this.handleTakePhoto = this.handleTakePhoto.bind(this);
        this.clearShowVideoTimeout = this.clearShowVideoTimeout.bind(this);
    }

    componentDidMount () {
        this.libCameraPhoto = new LibCameraPhoto(this.videoRef.current);
        const {idealFacingMode, idealResolution, isMaxResolution} = this.props;
        if (isMaxResolution) {
            this.startCameraMaxResolution(idealFacingMode);
        } else {
            this.startCameraIdealResolution(idealFacingMode, idealResolution);
        }
    }

  // eslint-disable-next-line
    UNSAFE_componentWillReceiveProps (nextProps) {
        if (isDynamicPropsUpdate(this.props, nextProps)) {
            const {idealFacingMode, idealResolution, isMaxResolution} = nextProps;
            this.restartCamera(idealFacingMode, idealResolution, isMaxResolution);
        }
    }

    componentWillUnmount () {
        this.clearShowVideoTimeout();
        const isComponentWillUnmount = true;
        this.stopCamera(isComponentWillUnmount)
        .catch((error) => {
            printCameraInfo(error.message);
        });
    }

    clearShowVideoTimeout () {
        if (this.showVideoTimeoutId) {
            clearTimeout(this.showVideoTimeoutId);
        }
    }

    restartCamera (idealFacingMode, idealResolution, isMaxResolution) {
        this.stopCamera()
        .then()
        .catch((error) => {
            printCameraInfo(error.message);
        })
        .then(() => {
            if (isMaxResolution) {
                this.startCameraMaxResolution(idealFacingMode);
            } else {
                this.startCameraIdealResolution(idealFacingMode, idealResolution);
            }
        });
    }

    startCamera (promiseStartCamera) {
        promiseStartCamera
        .then((stream) => {
            this.setState({
                isCameraStarted: true,
                startCameraErrorMsg: ''
            });
            if (typeof this.props.onCameraStart === 'function') {
                this.props.onCameraStart(stream);
            }
        })
        .catch((error) => {
            this.setState({
                startCameraErrorMsg: `${error.name} ${error.message}`
            });
            if (typeof this.props.onCameraError === 'function') {
                this.props.onCameraError(error);
            }
        });
    }

    startCameraIdealResolution (idealFacingMode, idealResolution) {
        let promiseStartCamera = this.libCameraPhoto.startCamera(idealFacingMode, idealResolution);
        this.startCamera(promiseStartCamera);
    }

    startCameraMaxResolution (idealFacingMode) {
        let promiseStartCamera = this.libCameraPhoto.startCameraMaxResolution(idealFacingMode);
        this.startCamera(promiseStartCamera);
    }

    stopCamera (isComponentWillUnmount = false) {
        return new Promise((resolve, reject) => {
        this.libCameraPhoto.stopCamera()
            .then(() => {
                if (!isComponentWillUnmount) {
                    this.setState({ isCameraStarted: false });
                }
                if (typeof this.props.onCameraStop === 'function') {
                    this.props.onCameraStop();
                }
                resolve();
            })
            .catch((error) => {
                if (typeof this.props.onCameraError === 'function') {
                    this.props.onCameraError(error);
                }
                reject(error);
            });
        });
    }

    handleTakePhoto () {
        const {sizeFactor, imageType, imageCompression, isImageMirror} = this.props;
        const configDataUri = { sizeFactor, imageType, imageCompression, isImageMirror };
        let dataUri = this.libCameraPhoto.getDataUri(configDataUri);

        if (this.props.onTakePhoto) {
            this.props.onTakePhoto(dataUri);
        }

        this.setState({
            dataUri,
            isShowVideo: false
        });

        this.clearShowVideoTimeout();
        this.showVideoTimeoutId = setTimeout(() => {
        this.setState({
            isShowVideo: true
        });

        if (this.props.onTakePhotoAnimationDone) {
            this.props.onTakePhotoAnimationDone(dataUri);
        }
        }, 900);
    }

    render () {
        const {isImageMirror} = this.props;
        const videoStyles = getVideoStyles(this.state.isShowVideo, isImageMirror);
        const wordHeader = "ถ่ายรูปสมุดบัญชี"
        const wordTitle = "กรุณาจัดตำแหน่งของหน้าสมุดบัญชีให้อยู่ในกรอบ"
        return (
            <>
              <StyledIcon type="left" onClick={this.props.onClick} />
              <ContainerCamera style={{width:this.props.resolution.width, height:this.props.resolution.height}}>
                  <Container/>
                  <ContainerWords>
                      <HeaderWords>{wordHeader}</HeaderWords>
                      <TitleWords>{wordTitle}</TitleWords>
                  </ContainerWords>
                  <MainVideo style={{width:this.props.resolution.width, height:this.props.resolution.height}}>
                    <Video
                      resolution = {{width:this.props.resolution.width, height:this.props.resolution.height}}
                      style={videoStyles}
                      ref={this.videoRef}
                      autoPlay
                      muted=""
                      preload="auto"
                      playsInline
                      />
                    </MainVideo>
                  <ContainerMask>
                      <Mask alt="imgMask" src={maskpng} />
                  </ContainerMask>
                  <ContainerCircles>
                      <OuterCircle onClick={this.handleTakePhoto}>
                          <InnerCircle />
                      </OuterCircle>
                  </ContainerCircles>
              </ContainerCamera>
              {this.state.dataUri &&
                  <img alt="imgCamera" src={this.state.dataUri} />
              }
            </>

        );
    }
}

export {
    Camera,
    FACING_MODES,
    IMAGE_TYPES
};

export default Camera;

Camera.propTypes = {
    onClick: PropTypes.func,
    onTakePhoto: PropTypes.func,
    onTakePhotoAnimationDone: PropTypes.func,
    onCameraError: PropTypes.func,
    idealFacingMode: PropTypes.string,
    idealResolution: PropTypes.object,
    resolution: PropTypes.object,
    imageType: PropTypes.string,
    isImageMirror: PropTypes.bool,
    isSilentMode: PropTypes.bool,
    isDisplayStartCameraError: PropTypes.bool,
    imageCompression: PropTypes.number,
    isMaxResolution: PropTypes.bool,
    sizeFactor: PropTypes.number,
    onCameraStart: PropTypes.func,
    onCameraStop: PropTypes.func
};

Camera.defaultProps = {
    isImageMirror: true,
    isDisplayStartCameraError: true
};